import React from 'react';
import ProductCard from './ProductCard';
import { useReveal } from '../utils/useReveal';

const ProductGrid = ({ items, variant = 'collection', onInquire, testIdPrefix }) => {
  const [ref, revealed] = useReveal();

  return (
    <div
      ref={ref}
      style={styles.grid}
      data-testid={`${testIdPrefix}-grid`}
      className={`product-grid-stagger ${revealed ? 'is-revealed' : ''}`}
    >
      {items.map((item, idx) => (
        <div
          key={item.id}
          className="product-card-reveal"
          style={{ '--i': idx }}
        >
          <ProductCard
            piece={item}
            variant={variant}
            onInquire={onInquire}
            testIdPrefix={testIdPrefix}
          />
        </div>
      ))}
    </div>
  );
};

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '28px 22px',
    maxWidth: '1280px',
    margin: '0 auto',
  },
};

const responsive = document.createElement('style');
responsive.textContent = `
  [data-testid$="-grid"] {
    display: grid;
    grid-template-columns: repeat(4, 1fr) !important;
    gap: 28px 22px;
    max-width: 1280px;
    margin: 0 auto;
  }
  @media (max-width: 1100px) {
    [data-testid$="-grid"] {
      grid-template-columns: repeat(3, 1fr) !important;
    }
  }
  @media (max-width: 760px) {
    [data-testid$="-grid"] {
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 20px 14px;
    }
  }
  @media (max-width: 420px) {
    [data-testid$="-grid"] {
      grid-template-columns: 1fr !important;
    }
  }
`;
document.head.appendChild(responsive);

export default ProductGrid;
